module.exports = __webpack_public_path__ + "img/house (1).5a42306f.svg";